<template>
  <div v-if="readyToRender" class="has-background-background height-100">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import initialiseGmapComponent from '@/services/general/map/initialiseGmapComponent';
import { createNamespacedHelpers } from 'vuex';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';

const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  name: 'App',
  data() {
    return {
      readyToRender: false,
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async setGmapComposant() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.token) {
          await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.googleMapApiKey.key]);
          await initialiseGmapComponent();
        }
        this.readyToRender = true;
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    async updateCategorieProduitDisponible() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.token) {
          await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.modulePresse.key]);
        }
      } catch (e) {
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  computed: {
    ...User.mapGetters({
      token: 'accessToken',
    }),
  },
  async updated() {
    await this.setGmapComposant();
    await this.updateCategorieProduitDisponible();
  },
  async created() {
    await this.setGmapComposant();
    await this.updateCategorieProduitDisponible();
  },
};
</script>

<style lang="scss">
  html{
    overflow: hidden!important;
    height: 100%;
  }
  body {
    height: 100%;
  }

  $size-1:36px;
  $size-2:30px;
  $size-3: 24px;
  $size-4: 18px;
  $size-5: 16px;
  $size-6: 14px;
  $size-7: 12px;
  $size-8: 10px;
  $gap: 40px;
  $body-size: 14px;
  $family-primary: 'Open Sans', sans-serif;
  $table-row-hover-background-color: #FBF1D0;
  $table-striped-row-even-hover-background-color: #FBF1D0;
  $input-placeholder-color:rgba(122, 122, 122, 0.7);

  $card-overflow: visible;

  @import "assets/style/color";

  $select-arrow-color: $link;

  @import "assets/style/navbar";
  @import "assets/style/font";
  @import "assets/style/table";
  @import "assets/style/table_echeancier";
  @import "assets/style/modal";
  @import "assets/style/obligatoire_fr";
  @import "assets/style/checkbox";
  @import "assets/style/sidebar";
  @import "assets/style/tab_echeancier";
  @import "assets/style/general";
  @import "assets/style/ripple";
  @import "assets/style/upload";
  @import "assets/style/facture";
  @import "assets/style/details";
  @import "assets/style/planning";
  @import "assets/style/steps";
  @import "assets/style/general_piecesjointes";
  @import "assets/style/catalogue";
  @import "assets/style/produit";
  @import "assets/style/animation";
  @import "assets/style/popup";
  @import "assets/style/article";
  @import "assets/style/disponibilite";
  @import "assets/style/permissions";
  @import "assets/style/gabed/emplacementSprite";
  @import "assets/style/gabed/componentSlideRight";
  @import "assets/style/gabed/emplacement";
  @import "assets/style/gabed/detailDispositif";
  @import "assets/style/parametrage";
  @import "assets/style/bouton";
  @import "assets/style/commande.scss";
  @import "assets/style/cheque.scss";
  @import "assets/style/optionBlocage.scss";
  @import "assets/style/datepicker.scss";
  @import "assets/style/tagInput.scss";
  @import "assets/style/logistique/affectation.scss";
  @import "assets/style/detailLigneCommandePrevisualisation";
  @import "assets/style/commentaireListInput";
  @import "assets/style/checkboxAsync";
  @import "assets/style/logistique/ressourceOt.scss";
  @import "assets/style/logistique/suiviProduction.scss";
  @import "assets/style/logo.scss";
  @import "assets/style/logistique/ordreTravail";
  @import "assets/style/logistique/demandeImpression";
  @import "assets/style/connexion";
  @import "assets/style/calendar";
  @import "assets/style/dropdown.scss";
  @import "assets/style/tooltip";
  @import "assets/style/dropdown";
  @import "assets/style/table_recapReseauDispo";
  @import "assets/style/table_selectionFaces";
  @import "assets/style/resize-img";
  @import "assets/style/azimut.scss";
  @import "assets/style/gabed/emplacementDispositifMaterielFacePicker";
  @import "assets/style/dropdown";
  @import "assets/style/spacing";
  @import "assets/style/jsonForm";
  @import "assets/style/step";
  @import "assets/style/codeInseeInput";
  @import "~bulma/sass/utilities/_all";

  @import "~bulma";

  @import "~buefy/src/scss/buefy";

</style>
